import React from "react";
import FAQ from "../containers/faqContainer";
import NavigationBar from "../components/Navigationbar";
import Footer from "../components/Footer";

export default () => (
  <div>
    <NavigationBar />
    <FAQ />
    <Footer />
  </div>
);
